var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBoxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.85 19.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke-width:1.5px;}.d,.e{fill:none;stroke:#888;stroke-miterlimit:10;}.e{stroke-width:1.94px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.13,10.55v5.34c0,1.85-1.5,3.35-3.35,3.35H4.1c-1.85,0-3.35-1.5-3.35-3.35V5.21c0-1.85,1.5-3.35,3.35-3.35h5.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 15.21,
    x2: 15.21,
    y2: 9.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 19.85,
    y1: 4.64,
    x2: 10.56,
    y2: 4.64
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBoxy);
export default __webpack_public_path__ + "static/media/addBoxy.8f023344ef81d694247767d7ecf20d60.svg";
export { ForwardRef as ReactComponent };